/**
 * The one name each kind of manifest discrepancy goes by, on every screen and
 * in every export. Keyed by `DiscrepancyKind`'s values.
 *
 * Three forms of the same words, so a screen picks the form its context needs
 * rather than rewording the name: `one` for a single finding or a filter
 * option, `many` for a count or list in running text, and `heading` for a
 * section title, summary tile or grid column.
 */
export const DISCREPANCY_KIND_NAMES = {
  FIELD_DISCREPANCY: {
    one: "Data source conflict",
    many: "Data source conflicts",
    heading: "Data Source Conflicts",
  },
  FIELD_ISSUE: {
    one: "Data quality issue",
    many: "Data quality issues",
    heading: "Data Quality Issues",
  },
  EMANIFEST_MISSING: {
    one: "Missing e-Manifest",
    many: "Missing e-Manifests",
    heading: "Missing e-Manifests",
  },
  EPA_CORRECTION_REQUEST: {
    one: "EPA-requested correction",
    many: "EPA-requested corrections",
    heading: "EPA-Requested Corrections",
  },
} as const satisfies Record<string, { one: string; many: string; heading: string }>;

export type DiscrepancyKindName = keyof typeof DISCREPANCY_KIND_NAMES;
